import { Link } from 'react-router-dom';

import CsIcon from '@/assets/icons/CsIcon.svg?react';
import ArrowRegularForwardIcon from '@/assets/icons/ArrowRegularForwardIcon.svg?react';
import { ROUTES } from '@/routes';
import { cn } from '@/utils/tailwind';
import { ChevronRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

type InquiryButtonProps = {
  className?: string;
  to?: string;
};

const InquiryButton = ({ className, to }: InquiryButtonProps) => {
  const navigate = useNavigate();
  const handleClick = () => {
    if (to) {
      navigate(to);
    } else {
      navigate(`${ROUTES.more}?ctab=support`);
    }
  };
  return (
    <div
      onClick={handleClick}
      className={cn(
        className,
        'flex cursor-pointer items-center gap-[12px] rounded-[16px] bg-white p-4',
      )}
    >
      <div className="flex h-[56px] w-[56px] items-center justify-center rounded-[50%] bg-gr-100">
        <CsIcon />
      </div>
      <div className="flex flex-col ">
        <p className="text-gr-800 Body1S16">마켓 연동에 어려움을 겪고 계신가요?</p>
        <div className="flex items-center gap-[2px]">
          <Link to={to ? to : ROUTES.inquiry} className="text-gr-700 Body5M14">
            1:1 문의 하기
          </Link>
          <ChevronRight className="h-5 w-5 text-gr-700" />
        </div>
      </div>
    </div>
  );
};

export default InquiryButton;
